/*
 * @Descripttion: 新增发票页
 * @Author: cb4786
 * @Date: 2023-08-10 17:34:29
 * @LastEditors: 黄佳鑫
 * @LastEditTime: 2026-02-24 13:36:55
 */

import useHook from './hooks'
import Styles from './styles.module.scss'
import TableAntd from '../../components/TableAntd'
import {
  Button,
  Col,
  DatePicker,
  Dropdown,
  Form,
  Input,
  MenuProps,
  Modal,
  Result,
  Row,
  Select,
  Space,
  Spin,
  Tooltip,
} from 'antd'
import { orderDetailLinkRender } from '../orderassurance/Lander'
import AddOrderModal from './components/AddOrderModal'
import moment from 'moment'
import {
  SignVoucherState,
  returnMoneyStatedictInvert,
  signVoucherStateDict,
} from '../../tools/state'
import { getTotalTaxAmountMismatchMessage } from './utils'
import {
  ExclamationCircleOutlined,
  CloseCircleOutlined,
  CheckCircleTwoTone,
  ReloadOutlined,
} from '@ant-design/icons'
import Customupload from '../../components/UploadFile'
import InvoiceEntryBatchModal, {
  invoiceFormItemLayout,
} from './components/InvoiceEntryBatchModal'
import { fileFile } from '../../modules/uploadfiles/hooks'
import DownloadIcon from '../../assets/img/download.png'
import PreviewModal from '../../components/previewModal'
import UploadSingleInvoice from './components/InvoiceEntryBatchModal/UploadSingleInvoice'
import { getInvoiceState } from '../MyInvoice/hooks'
import { formatStr, formatTime } from '../../tools/util'
import { toAssureOperationRender } from '../InvoiceEntry/SupplierInvoice'
import { FINANCIAL_INVOICE_FILE_TYPE, joinAddressInfo } from './reducer'
import { InvoiceNatureValue, invoiceTypeEnum } from '@/global/enum'
import AddReturnOrderModal from './components/AddReturnOrderModal'
import { FRONT_KEY } from '@/global/config'

export interface AddInvoiceEntryProps {
  pageType?: InvoiceNatureValue
}
function getRedRowKey(record: any) {
  return record[FRONT_KEY]
}
const AddInvoiceEntry = (props: AddInvoiceEntryProps) => {
  const { pageType = 'BLUE' } = props
  const {
    hooksState,
    fileInput,
    onChangeCheck,
    handleClosePage,
    handleSubmit,
    handleAddClick,
    handleAddOrderModalCancel,
    onDelete,
    handleAddFinished,
    onCopy,
    exrpotInvoiceWithOrder,
    invoiceForm,
    invoiceDetailForm,
    changeBatchModalVisible,
    onBatchModalSubmit,
    beforeUpload,
    getInputFile,
    showPreviewModal,
    cancelPreviewModal,
    onPackageDownload,
    handleDelInvoice,
    showInvoiceDetailModal,
    handleInvoiceDetailOk,
    handleInvoiceDetailCancel,
    changeInvoiceFile,
    invoiceDetailChange,
    handlefillingResult,
    reloadVerificationInvoice,
    jumpToInvoiceDetail,
    changeInvoiceListColumns,
    logisticsInfoForm,
    saveLogisticsInfo,
    changeInvoiceType,
    onLogisticsInfoFormChange,
    addressInfoMemo,
    handleAddReturnFinished,
    isTotalTaxAmoutNotEqualMemo,
  } = useHook(props)
  const {
    dataSource,
    isSubmitButtonLoading,
    isAddModalVisivle,
    originRemovedList,
    invoiceBatchModalVisible,
    batchUploadLoading,
    invoiceEntryType,
    invoiceListData,
    previewFileUrl,
    isPreviewModalVisible,
    allInvoicePrice,
    allOrderPrice,
    addInvoiceEntrySubmit,
    isModalOpen,
    invoiceDetailData,
    currentInvoice,
    checkingResult,
    exrpotInvoiceTip,
    isTemporaryStorageLoading,
    invoiceDetail,
    okBtnLoading,
    temporaryStorageDisabled,
    pageLoading,
    logisticsCompanyList,
    fileRequire,
    routeParams,
  } = hooksState

  // 发票类型
  const invoiceTypeRender = (text: any) => {
    return <span>{invoiceTypeEnum.getLabelByValue(text)}</span>
  }

  // 发票状态样式
  const stateStyle = (state: string) => {
    if (state === '1') {
      return {
        fontSize: '16px',
        color: '#fa8c16',
      }
    } else if (state === '2') {
      return {
        fontSize: '16px',
        color: '#888888',
      }
    } else if (state === '3') {
      return {
        fontSize: '16px',
        color: '#52c41a',
      }
    } else {
      return {
        fontSize: '16px',
        color: '#f5222d',
      }
    }
  }

  // 发票验真错误提示
  const toolTipList: any = {
    '1': '系统内已经有此发票',
    '2': '购方信息错误！',
    '4': '发票验真不通过',
    '5': '发票验真结果与已填写信息不匹配',
    '8': '销方信息错误',
    '9': '购方信息错误',
  }

  // 验真错误提示 + 慧穗云发票状态原因
  const renderVerifyTooltipTitle = (record: any) => {
    return (
      <span>
        <span>{toolTipList[record.verificationType]}</span>
        {record.verificationType === '4' && (
          <div style={{ fontSize: '12px', color: '#d9d9d9', marginTop: 2 }}>
            原因：
            {record.verificationFailureReason ?? '慧穗云发票状态返回null'}
          </div>
        )}
      </span>
    )
  }

  // 表格列数据
  const formConfig = {
    电商供应商订单明细: {
      columns: [
        {
          key: 'orderNo',
          dataIndex: 'orderNo',
          title: '客户订单号',
          render: orderDetailLinkRender,
        },
        {
          key: 'customer',
          dataIndex: 'customer',
          title: '客户名称',
        },
        {
          key: 'platform',
          dataIndex: 'platform',
          title: '下单平台',
        },
        {
          key: 'titleOfTheContract',
          dataIndex: 'titleOfTheContract',
          title: '签约抬头',
        },
        {
          key: 'orderTime',
          dataIndex: 'orderTime',
          title: '下单时间',
          render: (text: any) =>
            text !== '-' && moment(text).format('YYYY-MM-DD HH:mm:ss'),
        },

        {
          key: 'totalAmount',
          dataIndex: 'totalAmount',
          title: '合计金额',
        },
        {
          key: 'totalTaxAmount',
          dataIndex: 'totalTaxAmount',
          title: '合计税额',
        },
        {
          key: 'totalAmountIncludingTax',
          dataIndex: 'totalAmountIncludingTax',
          title: '价税合计',
        },

        {
          key: 'signVoucherState',
          dataIndex: 'signVoucherState',
          title: '签收凭证',
          render: (text: SignVoucherState) =>
            signVoucherStateDict[text] ?? text,
        },
        {
          key: 'returnState',
          dataIndex: 'returnState',
          title: '对账完毕',
          render: (text: any) =>
            returnMoneyStatedictInvert?.[text]?.name || text,
        },
      ],
    },
    供应商订单明细: {
      columns: [
        {
          key: 'code',
          title: '采购订单号',
          render: toAssureOperationRender,
        },
        {
          key: 'createTime',
          dataIndex: 'createTime',
          title: '创建时间',
          render: (text: number) =>
            text && moment(text).format('YYYY-MM-DD HH:mm'),
        },
        {
          key: 'receiveMan',
          dataIndex: 'receiveMan',
          title: '收件人',
        },
        {
          key: 'number',
          title: '结算件数',
        },
        {
          key: 'finalPrice',
          dataIndex: 'finalPrice',
          title: '最终结算金额',
        },
      ],
    },
    发票列表: {
      columns: [
        {
          key: 'invoiceType',
          dataIndex: 'invoiceType',
          title: '发票种类',
          width: 120,
          render: invoiceTypeRender,
        },
        {
          key: 'invoiceNum',
          dataIndex: 'invoiceNum',
          title: '发票号码',
          width: 120,
          render: (text: any, record: any, index: number) => {
            return (
              <span>
                {/* 验真中 */}
                {record.verificationType === '90' ? (
                  <span>
                    <span>{text}</span>
                    <span
                      style={{
                        marginLeft: '8px',
                        backgroundColor: '#fff7e6',
                        color: '#fa8c16',
                        padding: '0 4px',
                        borderRadius: '4px',
                      }}
                    >
                      验真中...
                    </span>
                  </span>
                ) : // 验真通过
                record.verificationType === '3' ? (
                  <span>
                    <span
                      style={{ color: '#3f7ad4', cursor: 'pointer' }}
                      onClick={() => {
                        showInvoiceDetailModal(record, index)
                      }}
                    >
                      {text}
                    </span>
                    <span
                      style={{
                        marginLeft: '8px',
                        backgroundColor: '#EEF8E8',
                        color: '#7AC756',
                        padding: '0 4px',
                        borderRadius: '4px',
                      }}
                    >
                      已验真
                    </span>
                  </span>
                ) : ['2', '4', '5', '9'].includes(record.verificationType) ? (
                  <span>
                    <Tooltip
                      title={renderVerifyTooltipTitle(record)}
                      getTooltipContainer={() => document.body}
                    >
                      <span
                        style={{ color: '#3f7ad4', cursor: 'pointer' }}
                        onClick={() => {
                          showInvoiceDetailModal(record, index)
                        }}
                      >
                        {text}
                      </span>
                      <CloseCircleOutlined
                        style={{ color: 'red', marginLeft: 6 }}
                      />
                    </Tooltip>
                  </span>
                ) : // 网络异常，请重试
                record.verificationType === '6' ? (
                  <>
                    <span>{text}</span>
                    <ReloadOutlined
                      style={{ color: 'red' }}
                      onClick={() => {
                        reloadVerificationInvoice(record, index)
                      }}
                    />
                  </>
                ) : // 发票在系统中已存在
                record.verificationType === '1' ||
                  record.verificationType === '8' ? (
                  <Tooltip
                    title={toolTipList[record.verificationType]}
                    getTooltipContainer={() => document.body}
                  >
                    <span>{text}</span>
                    <CloseCircleOutlined
                      style={{ color: 'red', marginLeft: 6 }}
                    />
                  </Tooltip>
                ) : // 当天开的发票，暂时无法验真，不可点击进入详情页，可以提交
                record.verificationType === '7' ? (
                  <span>{text}</span>
                ) : (
                  ''
                )}
              </span>
            )
          },
        },
        {
          key: 'invoiceCode',
          dataIndex: 'invoiceCode',
          title: '发票代码',
        },
        {
          key: 'invoiceTime',
          dataIndex: 'invoiceTime',
          title: '开票日期',
          render: (text: any) => moment(text).format('LL'),
        },
        {
          key: 'totalAmount',
          dataIndex: 'totalAmount',
          title: '合计金额',
        },
        {
          key: 'totalTaxAmount',
          dataIndex: 'totalTaxAmount',
          title: '合计税额',
        },
        {
          key: 'totalAmountIncludingTax',
          dataIndex: 'totalAmountIncludingTax',
          title: '价税合计',
        },
        {
          key: 'fileList',
          dataIndex: 'fileList',
          title: '发票附件',
          render: (text: fileFile[], record: any) => (
            <Space
              align="center"
              size={4}
              style={{
                width: '100%',
                flexWrap: 'wrap',
              }}
            >
              {record.fileList && record.fileList.length
                ? text.map((item, index) => (
                    <span key={index}>
                      {index > 0 ? (
                        <span style={{ marginRight: '4px' }}>,</span>
                      ) : null}
                      <span
                        className="primaryBtn"
                        onClick={() =>
                          showPreviewModal(item.baseUrl + item.url)
                        }
                      >
                        附件
                      </span>
                      <img
                        src={DownloadIcon}
                        alt=""
                        style={{
                          margin: '8px',
                          cursor: 'pointer',
                          width: '20px',
                          maxWidth: '20px',
                        }}
                        onClick={() => onPackageDownload(text)}
                      />
                    </span>
                  ))
                : '/'}
            </Space>
          ),
        },
        {
          key: 'operate',
          dataIndex: 'operate',
          title: '操作',
          render: (text: any, record: any, index: number) => (
            <span
              className={Styles['del-invoice']}
              onClick={() => handleDelInvoice(index)}
            >
              删除
            </span>
          ),
        },
      ],
    },
    发票详情: {
      columns: [
        {
          key: 'goodsName',
          dataIndex: 'goodsName',
          title: '货物或服务名称',
          width: 200,
        },
        {
          key: 'standard',
          dataIndex: 'standard',
          title: '规格型号',
        },
        {
          key: 'unit',
          dataIndex: 'unit',
          title: '单位',
          width: 50,
        },
        {
          key: 'num',
          dataIndex: 'num',
          title: '数量',
          width: 50,
        },
        {
          key: 'netValue',
          dataIndex: 'netValue',
          title: '单价',
          width: 140,
        },
        {
          key: 'detailAmount',
          dataIndex: 'detailAmount',
          title: '金额',
        },
        {
          key: 'taxRate',
          dataIndex: 'taxRate',
          title: '税率',
          width: 50,
        },
        {
          key: 'allTax',
          dataIndex: 'allTax',
          title: '税额',
        },
      ],
    },
    退货单明细: {
      columns: [
        {
          key: 'orderNo',
          dataIndex: 'orderNo',
          title: '客户订单号',
          // render: orderDetailLinkRender,
        },
        {
          key: 'returnNo',
          dataIndex: 'returnNo',
          title: '退货单',
        },
        {
          key: 'titleOfTheContractName',
          dataIndex: 'titleOfTheContractName',
          title: '签约抬头',
        },
        {
          key: 'returnTime',
          dataIndex: 'returnTime',
          title: '退货时间',
          render: (text: any) => (text ? formatTime(text) : ''),
        },
        {
          key: 'productCode',
          dataIndex: 'productCode',
          title: '物料编码',
        },
        {
          key: 'productName',
          dataIndex: 'productName',
          title: '商品名称',
        },
        {
          key: 'manuCode',
          dataIndex: 'manuCode',
          title: '规格型号',
        },
        {
          key: 'productPrice',
          dataIndex: 'productPrice',
          title: '单价',
        },
        {
          key: 'returnNum',
          dataIndex: 'returnNum',
          title: '退货数量',
        },
        {
          key: 'taxRate',
          dataIndex: 'taxRate',
          title: '税率',
          render: (text: number) => `${(text ?? 0) * 100}%`,
        },
        {
          key: 'totalAmount',
          dataIndex: 'totalAmount',
          title: '合计金额',
        },
        {
          key: 'totalTaxAmount',
          dataIndex: 'totalTaxAmount',
          title: '合计税额',
        },
        {
          key: 'totalAmountIncludingTax',
          dataIndex: 'totalAmountIncludingTax',
          title: '价税合计',
        },
      ],
    },
  }

  // 提交成功页面提示
  const subTitle = () => {
    return (
      <div>
        <div style={{ marginBottom: '20px' }}>
          若全部为电子发票，等待咸亨确认即可。
          <br />
          如有纸质发票，请打印寄票随单，并和发票一起寄送到以下地址：
        </div>
        <div
          style={{
            width: '390px',
            backgroundColor: '#fafafa',
            textAlign: 'left',
            padding: '16px',
            margin: '0 auto',
          }}
        >
          {routeParams.type === 'lander' ? (
            <span>
              {addressInfoMemo?.name}，{addressInfoMemo?.phone}
              <br />
              {addressInfoMemo?.address}
            </span>
          ) : (
            <span>
              收件人请填写您采购的联系方式，地址为：浙江省海宁市长安镇启辉路16号咸亨创新产业园1幢7楼
            </span>
          )}
          <span
            style={{
              display: 'inline-block',
              margin: '0 20px 0 8px',
              color: '#3c44d3',
              cursor: 'pointer',
            }}
            onClick={() => onCopy()}
          >
            复制
          </span>
        </div>
      </div>
    )
  }

  // 判断发票列表列数据是否包含'操作'项
  const invoiceListColumns = changeInvoiceListColumns(
    invoiceDetail.dataState as string,
    formConfig['发票列表'].columns,
  )

  const items: MenuProps['items'] = [
    {
      key: 'manual',
      label: (
        <Button
          type="link"
          onClick={() => {
            changeBatchModalVisible(true, 'manual')
          }}
        >
          手动填写
        </Button>
      ),
    },
    {
      key: 'batchUpload',
      label: (
        <Customupload
          accept={FINANCIAL_INVOICE_FILE_TYPE}
          uploadBtn={
            <Button type="link" size="small" style={{ margin: '0 0 10px 0' }}>
              批量导入发票
            </Button>
          }
          beforeUpload={beforeUpload}
          visibleFile={false}
          multiple
        />
      ),
    },
  ]

  return (
    <div>
      {addInvoiceEntrySubmit ? (
        <div style={{ minHeight: '100vh' }}>
          <Result
            status="success"
            title="提交成功"
            subTitle={subTitle()}
            extra={[
              <Button key="download" onClick={exrpotInvoiceWithOrder}>
                导出寄票随单
              </Button>,
              <Button
                key="toDetail"
                type="primary"
                onClick={jumpToInvoiceDetail}
              >
                前往查看
              </Button>,
            ]}
          />
        </div>
      ) : (
        <Spin spinning={pageLoading}>
          <div className={Styles['contianer']}>
            <div className={Styles['body']}>
              {addressInfoMemo && (
                <div className={Styles['ticket-email-add']}>
                  <ExclamationCircleOutlined
                    style={{ margin: '0 8px', color: '#faad15' }}
                  />
                  {joinAddressInfo(addressInfoMemo)}
                  <span
                    className={Styles['copy-address']}
                    onClick={() => onCopy()}
                  >
                    复制
                  </span>
                </div>
              )}

              <div className={Styles['logisticsInfo']}>
                <Form
                  form={logisticsInfoForm}
                  onFieldsChange={onLogisticsInfoFormChange}
                >
                  <Row>
                    <Col span={6}>
                      <Form.Item label="物流公司" name={'logisticsCompany'}>
                        <Select placeholder="请选择" allowClear showSearch>
                          {logisticsCompanyList?.map((item: any) => {
                            return (
                              <Select.Option
                                key={item.expressCode}
                                value={item.expressCompany}
                              >
                                {item.expressCompany}
                              </Select.Option>
                            )
                          })}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={2}></Col>
                    <Col span={6}>
                      <Form.Item
                        label="物流单号"
                        name={'logisticsNum'}
                        getValueFromEvent={(e) => {
                          return formatStr(e.target.value, 'TextNumber')
                        }}
                      >
                        <Input placeholder="请输入" maxLength={50}></Input>
                      </Form.Item>
                    </Col>
                    {(invoiceDetail.dataState === '1' ||
                      invoiceDetail.dataState === '3') && (
                      <Col>
                        <Button
                          type="primary"
                          style={{ marginLeft: '40px' }}
                          onClick={saveLogisticsInfo}
                        >
                          保存
                        </Button>
                      </Col>
                    )}
                  </Row>
                </Form>
              </div>
              <div className={Styles['invoice-info']}>
                <div
                  className={Styles['header']}
                  style={{ justifyContent: 'space-between' }}
                >
                  <span style={{ marginRight: 8 }}>
                    发票列表
                    <span
                      style={{ marginLeft: 16, border: 'null', fontSize: 14 }}
                    >
                      发票价税合计：{allInvoicePrice}
                    </span>
                    {/* 订单和发票列表都有数据的情况下判断是否展示提示 */}
                    {invoiceListData.length && dataSource.length ? (
                      isTotalTaxAmoutNotEqualMemo ? (
                        <span
                          style={{
                            marginLeft: 16,
                            border: 'null',
                            fontSize: 14,
                            color: '#cc3a16',
                          }}
                        >
                          <CloseCircleOutlined
                            style={{ color: '#cc3a16', marginRight: 6 }}
                          />
                          {getTotalTaxAmountMismatchMessage(
                            pageType,
                            routeParams.type,
                          )}
                        </span>
                      ) : (
                        ''
                      )
                    ) : (
                      ''
                    )}
                  </span>
                  {(!invoiceDetail ||
                    (invoiceDetail.dataState !== '1' &&
                      invoiceDetail.dataState !== '3')) && (
                    <Dropdown
                      menu={{ items }}
                      placement="bottom"
                      trigger={['click']}
                    >
                      <Button size="middle">上传发票</Button>
                    </Dropdown>
                  )}
                </div>
                <div className={Styles['invoice-info-list']}>
                  {!invoiceListData.length ? (
                    <div className={Styles['invoice-info-null']}>
                      暂无数据，您可以通过扫描
                      <span
                        className={Styles['invoice-info-btn']}
                        onClick={() => {
                          fileInput.current?.click()
                        }}
                      >
                        批量识别发票
                      </span>
                      发票，或
                      <span
                        className={Styles['invoice-info-btn']}
                        onClick={() => {
                          changeBatchModalVisible(true, 'manual')
                        }}
                      >
                        手动填写
                      </span>
                      <input
                        id="inputFile"
                        ref={fileInput}
                        type="file"
                        style={{ display: 'none' }}
                        onChange={(e) => getInputFile(e)}
                        multiple
                      />
                    </div>
                  ) : (
                    <div style={{ padding: '10px' }}>
                      <TableAntd
                        selfAdaptScroll
                        dataSource={invoiceListData}
                        listColumn={invoiceListColumns}
                        showSize={false}
                        loading={false}
                      ></TableAntd>
                    </div>
                  )}
                </div>
              </div>
              {pageType === 'BLUE' && (
                <div className={Styles['order-detail']}>
                  <Row justify="space-between" className={Styles['header']}>
                    <span>
                      订单明细
                      <span
                        style={{ marginLeft: 16, border: 'null', fontSize: 14 }}
                      >
                        订单价税合计：{allOrderPrice}
                      </span>
                    </span>
                    <Space size={16}>
                      {exrpotInvoiceTip && (
                        <span style={{ color: '#cc3a16', fontSize: '14px' }}>
                          电子票请直接传系统，纸质票请导出寄票随单并一起邮寄
                        </span>
                      )}
                      {(!invoiceDetail ||
                        (invoiceDetail.dataState !== '1' &&
                          invoiceDetail.dataState !== '3')) && (
                        <>
                          <Button
                            size="middle"
                            onClick={onDelete}
                            style={{ color: 'red' }}
                          >
                            删除
                          </Button>
                          <Button size="middle" onClick={handleAddClick}>
                            新增订单
                          </Button>
                        </>
                      )}
                      <Button
                        type="primary"
                        size="middle"
                        onClick={exrpotInvoiceWithOrder}
                      >
                        导出寄票随单
                      </Button>
                    </Space>
                  </Row>
                  <div className={Styles['table-container']}>
                    <TableAntd
                      dataSource={dataSource}
                      listColumn={
                        formConfig[
                          routeParams.type === 'lander'
                            ? '电商供应商订单明细'
                            : '供应商订单明细'
                        ].columns
                      }
                      showSize={false}
                      loading={false}
                      onChangeCheck={onChangeCheck}
                      selfAdaptScroll
                    ></TableAntd>
                  </div>
                </div>
              )}
              {pageType === 'RED' && (
                <div className={Styles['order-detail']}>
                  <Row justify="space-between" className={Styles['header']}>
                    <span>
                      退货单明细
                      <span
                        style={{ marginLeft: 16, border: 'null', fontSize: 14 }}
                      >
                        退货单价税合计：{allOrderPrice}
                      </span>
                    </span>
                    <Space size={16}>
                      {exrpotInvoiceTip && (
                        <span style={{ color: '#cc3a16', fontSize: '14px' }}>
                          电子票请直接传系统，纸质票请导出寄票随单并一起邮寄
                        </span>
                      )}
                      {(!invoiceDetail ||
                        (invoiceDetail.dataState !== '1' &&
                          invoiceDetail.dataState !== '3')) && (
                        <>
                          <Button
                            size="middle"
                            onClick={onDelete}
                            style={{ color: 'red' }}
                          >
                            删除
                          </Button>
                          <Button size="middle" onClick={handleAddClick}>
                            新增退货单
                          </Button>
                        </>
                      )}
                      <Button
                        type="primary"
                        size="middle"
                        onClick={exrpotInvoiceWithOrder}
                      >
                        导出寄票随单
                      </Button>
                    </Space>
                  </Row>
                  <div className={Styles['table-container']}>
                    <TableAntd
                      dataSource={dataSource}
                      listColumn={formConfig['退货单明细'].columns}
                      showSize={false}
                      loading={false}
                      onChangeCheck={onChangeCheck}
                      selfAdaptScroll
                      rowKey={pageType === 'RED' ? getRedRowKey : undefined}
                    ></TableAntd>
                  </div>
                </div>
              )}
            </div>
            <div className={Styles['bottom-buttons-container']}>
              <Space style={{ marginRight: '20px' }}>
                {invoiceDetail.dataState ? (
                  invoiceDetail.dataState === '4' ? (
                    <div style={stateStyle(invoiceDetail.dataState)}>
                      {getInvoiceState(invoiceDetail.dataState)}
                      <span>理由:{invoiceDetail.rejection}</span>
                    </div>
                  ) : (
                    <div style={stateStyle(invoiceDetail.dataState)}>
                      {getInvoiceState(invoiceDetail.dataState)}
                    </div>
                  )
                ) : (
                  <div style={{ width: '10px' }}></div>
                )}
              </Space>
              {!invoiceDetail ||
              (invoiceDetail.dataState !== '1' &&
                invoiceDetail.dataState !== '3') ? (
                <Space>
                  <Button
                    disabled={
                      isSubmitButtonLoading || isTemporaryStorageLoading
                    }
                    onClick={handleClosePage}
                  >
                    取消
                  </Button>
                  {(!invoiceDetail || invoiceDetail.dataState !== '4') && (
                    <Button
                      onClick={() => handleSubmit('temporaryStorage')}
                      loading={isTemporaryStorageLoading}
                      disabled={
                        isSubmitButtonLoading || temporaryStorageDisabled
                      }
                    >
                      暂存
                    </Button>
                  )}
                  <Button
                    type="primary"
                    onClick={() => handleSubmit('submit')}
                    className={Styles['button-item']}
                    loading={isSubmitButtonLoading}
                    disabled={isTemporaryStorageLoading}
                  >
                    提交
                  </Button>
                </Space>
              ) : (
                <></>
              )}
            </div>
            {pageType === 'RED' && (
              <AddReturnOrderModal
                open={isAddModalVisivle}
                modalConfirm={handleAddReturnFinished}
                modalCancel={handleAddOrderModalCancel}
                excludeOrderIds={dataSource.map((item) => item.id)}
                originRemovedList={originRemovedList}
                type={routeParams.type!}
              />
            )}
            {/* 添加订单弹框 */}
            {pageType === 'BLUE' && (
              <AddOrderModal
                open={isAddModalVisivle}
                modalConfirm={handleAddFinished}
                modalCancel={handleAddOrderModalCancel}
                excludeOrderIds={dataSource.map((item) => item.id)}
                originRemovedList={originRemovedList}
                type={routeParams.type!}
              />
            )}
            {/* 上传发票弹框 */}
            <InvoiceEntryBatchModal
              form={invoiceForm}
              open={invoiceBatchModalVisible}
              modalCancel={() => changeBatchModalVisible(false)}
              modalSubmit={onBatchModalSubmit}
              type={invoiceEntryType}
              loading={batchUploadLoading}
              okBtnLoading={okBtnLoading}
              invoiceNature={pageType}
            />
            {/* 发票附件预览 */}
            <PreviewModal
              open={isPreviewModalVisible}
              fileUrl={previewFileUrl}
              onCancel={cancelPreviewModal}
            />
            {/* 发票详情弹框 */}
            <Modal
              title="发票详情"
              open={isModalOpen}
              onOk={handleInvoiceDetailOk}
              onCancel={handleInvoiceDetailCancel}
              width={1100}
              keyboard={false}
              maskClosable={false}
            >
              {currentInvoice.verificationType !== '3' &&
                currentInvoice.verificationType !== '90' && (
                  <div
                    style={{
                      marginBottom: '12px',
                      color: '#595454',
                      backgroundColor: '#fff1f0',
                      border: '1px solid #ffa39e',
                      borderRadius: '4px',
                      padding: '4px',
                    }}
                  >
                    {currentInvoice.verificationType === '4' ? (
                      <span>
                        <CloseCircleOutlined
                          style={{ color: 'red', marginRight: 6 }}
                        />
                        发票验真不通过，请检查您的信息是否正确，或直接上传发票扫描件
                      </span>
                    ) : currentInvoice.verificationType === '2' ? (
                      <span>
                        <CloseCircleOutlined
                          style={{ color: 'red', marginRight: 6 }}
                        />
                        {`购方名称错误！发票抬头请开给${
                          routeParams?.titleOfTheContract ??
                          '万聚国际（杭州）供应链有限公司'
                        }！`}
                      </span>
                    ) : currentInvoice.verificationType === '5' ? (
                      <span>
                        <CloseCircleOutlined
                          style={{ color: 'red', marginRight: 6 }}
                        />
                        验真结果与已填信息不一致
                        <span
                          style={{ color: '#3f7ad4', cursor: 'pointer' }}
                          onClick={handlefillingResult}
                        >
                          填充验真结果
                        </span>
                      </span>
                    ) : (
                      ''
                    )}
                  </div>
                )}
              <div>
                <Form
                  form={invoiceDetailForm}
                  onFieldsChange={invoiceDetailChange}
                >
                  <Row>
                    <Form.Item
                      name={'fileList'}
                      label="发票附件"
                      style={{
                        width: '40%',
                        marginBottom: 0,
                      }}
                      rules={[
                        {
                          required: fileRequire,
                          message: '请上传电子发票的发票附件',
                        },
                      ]}
                    >
                      <UploadSingleInvoice
                        hiddenDownload
                        value={currentInvoice.fileList}
                        disabled={currentInvoice.verificationType !== '4'}
                        onChange={(file) => changeInvoiceFile(file)}
                      />
                      {currentInvoice.verificationType === '4' ? (
                        <span
                          style={{
                            marginLeft: '8px',
                            backgroundColor: '#fff1f0',
                            color: '#ff0000',
                            padding: '0 4px',
                            borderRadius: '4px',
                          }}
                        >
                          验真失败
                        </span>
                      ) : currentInvoice.verificationType !== '90' ? (
                        <span
                          style={{
                            marginLeft: '8px',
                            backgroundColor: '#EEF8E8',
                            color: '#7AC756',
                            padding: '0 4px',
                            borderRadius: '4px',
                          }}
                        >
                          已验真
                        </span>
                      ) : (
                        ''
                      )}
                    </Form.Item>
                    <Form.Item
                      {...invoiceFormItemLayout}
                      label="发票种类"
                      name={'invoiceType'}
                      rules={[{ message: '请选择', required: true }]}
                    >
                      <Select
                        placeholder="请选择"
                        disabled={currentInvoice.verificationType !== '4'}
                        onSelect={(value: string) => {
                          changeInvoiceType(value)
                        }}
                        options={invoiceTypeEnum}
                      ></Select>
                    </Form.Item>
                  </Row>
                  {currentInvoice.verificationType === '5' ? (
                    <Row style={{ marginTop: '-20px', color: 'red' }}>
                      <Col span={9} style={{ paddingLeft: '80px' }}></Col>
                      <Col span={7} style={{ paddingLeft: '36px' }}>
                        {checkingResult?.invoiceType !==
                        currentInvoice.invoiceType
                          ? `验真结果：${
                              invoiceTypeEnum.getLabelByValue(
                                checkingResult?.invoiceType,
                              ) ?? '-'
                            }`
                          : ''}
                      </Col>
                    </Row>
                  ) : (
                    <div></div>
                  )}
                  <Row>
                    <Form.Item
                      {...invoiceFormItemLayout}
                      name={'invoiceNum'}
                      label={'发票号码'}
                      rules={[
                        {
                          required: true,
                          message: '请输入',
                        },
                      ]}
                    >
                      <Input
                        placeholder="请输入"
                        disabled={currentInvoice.verificationType !== '4'}
                      ></Input>
                    </Form.Item>
                    <Form.Item
                      {...invoiceFormItemLayout}
                      name={'invoiceCode'}
                      label={'发票代码'}
                      rules={[
                        {
                          required: !invoiceTypeEnum.isLabelsMatchValue(
                            [
                              '电子发票（增值税专用发票）',
                              '电子发票（普通发票）',
                            ],
                            invoiceDetailForm.getFieldValue('invoiceType'),
                          ),
                          message: '请输入',
                        },
                      ]}
                    >
                      <Input
                        placeholder="请输入"
                        disabled={currentInvoice.verificationType !== '4'}
                      ></Input>
                    </Form.Item>
                    <Form.Item
                      {...invoiceFormItemLayout}
                      name={'invoiceTime'}
                      label={'开票日期'}
                      rules={[
                        {
                          required: true,
                          message: '请选择日期',
                        },
                      ]}
                    >
                      <DatePicker
                        disabled={currentInvoice.verificationType !== '4'}
                      />
                    </Form.Item>
                  </Row>
                  {currentInvoice.verificationType === '5' ? (
                    <Row style={{ marginTop: '-20px', color: 'red' }}>
                      <Col span={8} style={{ paddingLeft: '80px' }}></Col>
                      <Col span={7} style={{ paddingLeft: '42px' }}>
                        {checkingResult?.invoiceCode !==
                        currentInvoice.invoiceCode
                          ? `验真结果：${checkingResult?.invoiceCode}`
                          : ''}
                      </Col>
                      <Col span={8} style={{ paddingLeft: '70px' }}>
                        {checkingResult?.invoiceTime !==
                        moment(currentInvoice.invoiceTime).format('YYYYMMDD')
                          ? `验真结果：${moment(
                              checkingResult?.invoiceTime,
                            ).format('YYYY-MM-DD')}`
                          : ''}
                      </Col>
                    </Row>
                  ) : (
                    <div></div>
                  )}
                  <Row>
                    <Form.Item
                      {...invoiceFormItemLayout}
                      name={'totalAmount'}
                      label={'合计金额'}
                      rules={[
                        {
                          required: true,
                          pattern: /^(0\.\d{1,2}|[1-9]\d*(\.\d{1,2})?)$/,
                          message: '仅支持大于零的两位小数',
                        },
                      ]}
                    >
                      <Input
                        placeholder="请输入"
                        disabled={currentInvoice.verificationType !== '4'}
                      ></Input>
                    </Form.Item>
                    <Form.Item
                      {...invoiceFormItemLayout}
                      name={'totalTaxAmount'}
                      label={'合计税额'}
                      rules={[
                        {
                          pattern: /^(0\.\d{1,2}|[1-9]\d*(\.\d{1,2})?)$/,
                          message: '仅支持大于零的两位小数',
                        },
                      ]}
                    >
                      <Input
                        placeholder="请输入"
                        disabled={currentInvoice.verificationType !== '4'}
                      ></Input>
                    </Form.Item>
                    <Form.Item
                      {...invoiceFormItemLayout}
                      name={'totalAmountIncludingTax'}
                      label={'价税合计'}
                      rules={[
                        {
                          required: true,
                          pattern: /^(0\.\d{1,2}|[1-9]\d*(\.\d{1,2})?)$/,
                          message: '仅支持大于零的两位小数',
                        },
                      ]}
                    >
                      <Input
                        placeholder="请输入"
                        disabled={currentInvoice.verificationType !== '4'}
                      ></Input>
                    </Form.Item>
                  </Row>
                  {currentInvoice.verificationType === '5' ? (
                    <Row style={{ marginTop: '-20px', color: 'red' }}>
                      <Col span={8} style={{ paddingLeft: '80px' }}>
                        {checkingResult?.totalAmount !==
                        currentInvoice.totalAmount
                          ? `验真结果：${checkingResult?.totalAmount}`
                          : ''}
                      </Col>
                      <Col span={7} style={{ paddingLeft: '42px' }}>
                        {checkingResult?.totalTaxAmount !==
                        currentInvoice.totalTaxAmount
                          ? `验真结果：${checkingResult?.totalTaxAmount}`
                          : ''}
                      </Col>
                      <Col span={8} style={{ paddingLeft: '70px' }}>
                        {checkingResult?.totalAmountIncludingTax !==
                        currentInvoice.totalAmountIncludingTax
                          ? `验真结果：${checkingResult?.totalAmountIncludingTax}`
                          : ''}
                      </Col>
                    </Row>
                  ) : (
                    <div></div>
                  )}
                  {invoiceDetailForm.getFieldValue('invoiceType') === '04' && (
                    <Row style={{ marginLeft: '14px' }}>
                      <Form.Item
                        style={{
                          width: '29%',
                        }}
                        label={'校验码'}
                        name={'checkCode'}
                        rules={[
                          {
                            required: true,
                            message: '请输入校验码',
                          },
                        ]}
                        getValueFromEvent={(e) => {
                          return formatStr(e.target.value, 'Number')
                        }}
                      >
                        <Input
                          placeholder="请输入"
                          disabled={currentInvoice.verificationType !== '4'}
                          maxLength={6}
                        ></Input>
                      </Form.Item>
                      {currentInvoice.verificationType === '4' && (
                        <span
                          style={{
                            marginTop: '2px',
                            marginLeft: '8px',
                            fontSize: '12px',
                            color: '#CCCCCC',
                          }}
                        >
                          填写后六位
                        </span>
                      )}
                    </Row>
                  )}
                </Form>
              </div>
              {currentInvoice.verificationType !== '4' &&
                currentInvoice.verificationType !== '90' && (
                  <span>
                    购方名称：{currentInvoice.purchaserName}
                    {currentInvoice.verificationType === '2' ? (
                      <CloseCircleOutlined
                        style={{ color: 'red', marginLeft: 6 }}
                      />
                    ) : (
                      <CheckCircleTwoTone twoToneColor="#52c41a" />
                    )}
                  </span>
                )}
              {currentInvoice.verificationType !== '4' &&
              currentInvoice.verificationType !== '90' ? (
                <div>
                  <TableAntd
                    selfAdaptScroll
                    dataSource={invoiceDetailData}
                    listColumn={formConfig['发票详情'].columns}
                    showSize={false}
                    loading={false}
                  ></TableAntd>
                  <span style={{ display: 'inline-block', marginTop: '8px' }}>
                    备注: {currentInvoice.note || '-'}
                  </span>
                </div>
              ) : (
                ''
              )}
            </Modal>
          </div>
        </Spin>
      )}
    </div>
  )
}

export default AddInvoiceEntry
/*
 * @Descripttion: 新增发票页
 * @Author: cb4786
 * @Date: 2023-08-10 17:34:29
 * @LastEditors: 黄佳鑫
 * @LastEditTime: 2026-02-24 13:36:55
 */

import useHook from './hooks'
import Styles from './styles.module.scss'
import TableAntd from '../../components/TableAntd'
import {
  Button,
  Col,
  DatePicker,
  Dropdown,
  Form,
  Input,
  MenuProps,
  Modal,
  Result,
  Row,
  Select,
  Space,
  Spin,
  Tooltip,
} from 'antd'
import { orderDetailLinkRender } from '../orderassurance/Lander'
import AddOrderModal from './components/AddOrderModal'
import moment from 'moment'
import {
  SignVoucherState,
  returnMoneyStatedictInvert,
  signVoucherStateDict,
} from '../../tools/state'
import { getTotalTaxAmountMismatchMessage } from './utils'
import {
  ExclamationCircleOutlined,
  CloseCircleOutlined,
  CheckCircleTwoTone,
  ReloadOutlined,
} from '@ant-design/icons'
import Customupload from '../../components/UploadFile'
import InvoiceEntryBatchModal, {
  invoiceFormItemLayout,
} from './components/InvoiceEntryBatchModal'
import { fileFile } from '../../modules/uploadfiles/hooks'
import DownloadIcon from '../../assets/img/download.png'
import PreviewModal from '../../components/previewModal'
import UploadSingleInvoice from './components/InvoiceEntryBatchModal/UploadSingleInvoice'
import { getInvoiceState } from '../MyInvoice/hooks'
import { formatStr, formatTime } from '../../tools/util'
import { toAssureOperationRender } from '../InvoiceEntry/SupplierInvoice'
import { FINANCIAL_INVOICE_FILE_TYPE, joinAddressInfo } from './reducer'
import { InvoiceNatureValue, invoiceTypeEnum } from '@/global/enum'
import AddReturnOrderModal from './components/AddReturnOrderModal'
import { FRONT_KEY } from '@/global/config'

export interface AddInvoiceEntryProps {
  pageType?: InvoiceNatureValue
}
function getRedRowKey(record: any) {
  return record[FRONT_KEY]
}
const AddInvoiceEntry = (props: AddInvoiceEntryProps) => {
  const { pageType = 'BLUE' } = props
  const {
    hooksState,
    fileInput,
    onChangeCheck,
    handleClosePage,
    handleSubmit,
    handleAddClick,
    handleAddOrderModalCancel,
    onDelete,
    handleAddFinished,
    onCopy,
    exrpotInvoiceWithOrder,
    invoiceForm,
    invoiceDetailForm,
    changeBatchModalVisible,
    onBatchModalSubmit,
    beforeUpload,
    getInputFile,
    showPreviewModal,
    cancelPreviewModal,
    onPackageDownload,
    handleDelInvoice,
    showInvoiceDetailModal,
    handleInvoiceDetailOk,
    handleInvoiceDetailCancel,
    changeInvoiceFile,
    invoiceDetailChange,
    handlefillingResult,
    reloadVerificationInvoice,
    jumpToInvoiceDetail,
    changeInvoiceListColumns,
    logisticsInfoForm,
    saveLogisticsInfo,
    changeInvoiceType,
    onLogisticsInfoFormChange,
    addressInfoMemo,
    handleAddReturnFinished,
    isTotalTaxAmoutNotEqualMemo,
  } = useHook(props)
  const {
    dataSource,
    isSubmitButtonLoading,
    isAddModalVisivle,
    originRemovedList,
    invoiceBatchModalVisible,
    batchUploadLoading,
    invoiceEntryType,
    invoiceListData,
    previewFileUrl,
    isPreviewModalVisible,
    allInvoicePrice,
    allOrderPrice,
    addInvoiceEntrySubmit,
    isModalOpen,
    invoiceDetailData,
    currentInvoice,
    checkingResult,
    exrpotInvoiceTip,
    isTemporaryStorageLoading,
    invoiceDetail,
    okBtnLoading,
    temporaryStorageDisabled,
    pageLoading,
    logisticsCompanyList,
    fileRequire,
    routeParams,
  } = hooksState

  // 发票类型
  const invoiceTypeRender = (text: any) => {
    return <span>{invoiceTypeEnum.getLabelByValue(text)}</span>
  }

  // 发票状态样式
  const stateStyle = (state: string) => {
    if (state === '1') {
      return {
        fontSize: '16px',
        color: '#fa8c16',
      }
    } else if (state === '2') {
      return {
        fontSize: '16px',
        color: '#888888',
      }
    } else if (state === '3') {
      return {
        fontSize: '16px',
        color: '#52c41a',
      }
    } else {
      return {
        fontSize: '16px',
        color: '#f5222d',
      }
    }
  }

  // 发票验真错误提示
  const toolTipList: any = {
    '1': '系统内已经有此发票',
    '2': '购方信息错误！',
    '4': '发票验真不通过',
    '5': '发票验真结果与已填写信息不匹配',
    '8': '销方信息错误',
    '9': '购方信息错误',
  }

  // 验真错误提示 + 慧穗云发票状态原因
  const renderVerifyTooltipTitle = (record: any) => {
    return (
      <span>
        <span>{toolTipList[record.verificationType]}</span>
        {record.verificationType === '4' && (
          <div style={{ fontSize: '12px', color: '#d9d9d9', marginTop: 2 }}>
            原因：
            {record.verificationFailureReason ?? '慧穗云发票状态返回null'}
          </div>
        )}
      </span>
    )
  }

  // 表格列数据
  const formConfig = {
    电商供应商订单明细: {
      columns: [
        {
          key: 'orderNo',
          dataIndex: 'orderNo',
          title: '客户订单号',
          render: orderDetailLinkRender,
        },
        {
          key: 'customer',
          dataIndex: 'customer',
          title: '客户名称',
        },
        {
          key: 'platform',
          dataIndex: 'platform',
          title: '下单平台',
        },
        {
          key: 'titleOfTheContract',
          dataIndex: 'titleOfTheContract',
          title: '签约抬头',
        },
        {
          key: 'orderTime',
          dataIndex: 'orderTime',
          title: '下单时间',
          render: (text: any) =>
            text !== '-' && moment(text).format('YYYY-MM-DD HH:mm:ss'),
        },

        {
          key: 'totalAmount',
          dataIndex: 'totalAmount',
          title: '合计金额',
        },
        {
          key: 'totalTaxAmount',
          dataIndex: 'totalTaxAmount',
          title: '合计税额',
        },
        {
          key: 'totalAmountIncludingTax',
          dataIndex: 'totalAmountIncludingTax',
          title: '价税合计',
        },

        {
          key: 'signVoucherState',
          dataIndex: 'signVoucherState',
          title: '签收凭证',
          render: (text: SignVoucherState) =>
            signVoucherStateDict[text] ?? text,
        },
        {
          key: 'returnState',
          dataIndex: 'returnState',
          title: '对账完毕',
          render: (text: any) =>
            returnMoneyStatedictInvert?.[text]?.name || text,
        },
      ],
    },
    供应商订单明细: {
      columns: [
        {
          key: 'code',
          title: '采购订单号',
          render: toAssureOperationRender,
        },
        {
          key: 'createTime',
          dataIndex: 'createTime',
          title: '创建时间',
          render: (text: number) =>
            text && moment(text).format('YYYY-MM-DD HH:mm'),
        },
        {
          key: 'receiveMan',
          dataIndex: 'receiveMan',
          title: '收件人',
        },
        {
          key: 'number',
          title: '结算件数',
        },
        {
          key: 'finalPrice',
          dataIndex: 'finalPrice',
          title: '最终结算金额',
        },
      ],
    },
    发票列表: {
      columns: [
        {
          key: 'invoiceType',
          dataIndex: 'invoiceType',
          title: '发票种类',
          width: 120,
          render: invoiceTypeRender,
        },
        {
          key: 'invoiceNum',
          dataIndex: 'invoiceNum',
          title: '发票号码',
          width: 120,
          render: (text: any, record: any, index: number) => {
            return (
              <span>
                {/* 验真中 */}
                {record.verificationType === '90' ? (
                  <span>
                    <span>{text}</span>
                    <span
                      style={{
                        marginLeft: '8px',
                        backgroundColor: '#fff7e6',
                        color: '#fa8c16',
                        padding: '0 4px',
                        borderRadius: '4px',
                      }}
                    >
                      验真中...
                    </span>
                  </span>
                ) : // 验真通过
                record.verificationType === '3' ? (
                  <span>
                    <span
                      style={{ color: '#3f7ad4', cursor: 'pointer' }}
                      onClick={() => {
                        showInvoiceDetailModal(record, index)
                      }}
                    >
                      {text}
                    </span>
                    <span
                      style={{
                        marginLeft: '8px',
                        backgroundColor: '#EEF8E8',
                        color: '#7AC756',
                        padding: '0 4px',
                        borderRadius: '4px',
                      }}
                    >
                      已验真
                    </span>
                  </span>
                ) : ['2', '4', '5', '9'].includes(record.verificationType) ? (
                  <span>
                    <Tooltip
                      title={renderVerifyTooltipTitle(record)}
                      getTooltipContainer={() => document.body}
                    >
                      <span
                        style={{ color: '#3f7ad4', cursor: 'pointer' }}
                        onClick={() => {
                          showInvoiceDetailModal(record, index)
                        }}
                      >
                        {text}
                      </span>
                      <CloseCircleOutlined
                        style={{ color: 'red', marginLeft: 6 }}
                      />
                    </Tooltip>
                  </span>
                ) : // 网络异常，请重试
                record.verificationType === '6' ? (
                  <>
                    <span>{text}</span>
                    <ReloadOutlined
                      style={{ color: 'red' }}
                      onClick={() => {
                        reloadVerificationInvoice(record, index)
                      }}
                    />
                  </>
                ) : // 发票在系统中已存在
                record.verificationType === '1' ||
                  record.verificationType === '8' ? (
                  <Tooltip
                    title={toolTipList[record.verificationType]}
                    getTooltipContainer={() => document.body}
                  >
                    <span>{text}</span>
                    <CloseCircleOutlined
                      style={{ color: 'red', marginLeft: 6 }}
                    />
                  </Tooltip>
                ) : // 当天开的发票，暂时无法验真，不可点击进入详情页，可以提交
                record.verificationType === '7' ? (
                  <span>{text}</span>
                ) : (
                  ''
                )}
              </span>
            )
          },
        },
        {
          key: 'invoiceCode',
          dataIndex: 'invoiceCode',
          title: '发票代码',
        },
        {
          key: 'invoiceTime',
          dataIndex: 'invoiceTime',
          title: '开票日期',
          render: (text: any) => moment(text).format('LL'),
        },
        {
          key: 'totalAmount',
          dataIndex: 'totalAmount',
          title: '合计金额',
        },
        {
          key: 'totalTaxAmount',
          dataIndex: 'totalTaxAmount',
          title: '合计税额',
        },
        {
          key: 'totalAmountIncludingTax',
          dataIndex: 'totalAmountIncludingTax',
          title: '价税合计',
        },
        {
          key: 'fileList',
          dataIndex: 'fileList',
          title: '发票附件',
          render: (text: fileFile[], record: any) => (
            <Space
              align="center"
              size={4}
              style={{
                width: '100%',
                flexWrap: 'wrap',
              }}
            >
              {record.fileList && record.fileList.length
                ? text.map((item, index) => (
                    <span key={index}>
                      {index > 0 ? (
                        <span style={{ marginRight: '4px' }}>,</span>
                      ) : null}
                      <span
                        className="primaryBtn"
                        onClick={() =>
                          showPreviewModal(item.baseUrl + item.url)
                        }
                      >
                        附件
                      </span>
                      <img
                        src={DownloadIcon}
                        alt=""
                        style={{
                          margin: '8px',
                          cursor: 'pointer',
                          width: '20px',
                          maxWidth: '20px',
                        }}
                        onClick={() => onPackageDownload(text)}
                      />
                    </span>
                  ))
                : '/'}
            </Space>
          ),
        },
        {
          key: 'operate',
          dataIndex: 'operate',
          title: '操作',
          render: (text: any, record: any, index: number) => (
            <span
              className={Styles['del-invoice']}
              onClick={() => handleDelInvoice(index)}
            >
              删除
            </span>
          ),
        },
      ],
    },
    发票详情: {
      columns: [
        {
          key: 'goodsName',
          dataIndex: 'goodsName',
          title: '货物或服务名称',
          width: 200,
        },
        {
          key: 'standard',
          dataIndex: 'standard',
          title: '规格型号',
        },
        {
          key: 'unit',
          dataIndex: 'unit',
          title: '单位',
          width: 50,
        },
        {
          key: 'num',
          dataIndex: 'num',
          title: '数量',
          width: 50,
        },
        {
          key: 'netValue',
          dataIndex: 'netValue',
          title: '单价',
          width: 140,
        },
        {
          key: 'detailAmount',
          dataIndex: 'detailAmount',
          title: '金额',
        },
        {
          key: 'taxRate',
          dataIndex: 'taxRate',
          title: '税率',
          width: 50,
        },
        {
          key: 'allTax',
          dataIndex: 'allTax',
          title: '税额',
        },
      ],
    },
    退货单明细: {
      columns: [
        {
          key: 'orderNo',
          dataIndex: 'orderNo',
          title: '客户订单号',
          // render: orderDetailLinkRender,
        },
        {
          key: 'returnNo',
          dataIndex: 'returnNo',
          title: '退货单',
        },
        {
          key: 'titleOfTheContractName',
          dataIndex: 'titleOfTheContractName',
          title: '签约抬头',
        },
        {
          key: 'returnTime',
          dataIndex: 'returnTime',
          title: '退货时间',
          render: (text: any) => (text ? formatTime(text) : ''),
        },
        {
          key: 'productCode',
          dataIndex: 'productCode',
          title: '物料编码',
        },
        {
          key: 'productName',
          dataIndex: 'productName',
          title: '商品名称',
        },
        {
          key: 'manuCode',
          dataIndex: 'manuCode',
          title: '规格型号',
        },
        {
          key: 'productPrice',
          dataIndex: 'productPrice',
          title: '单价',
        },
        {
          key: 'returnNum',
          dataIndex: 'returnNum',
          title: '退货数量',
        },
        {
          key: 'taxRate',
          dataIndex: 'taxRate',
          title: '税率',
          render: (text: number) => `${(text ?? 0) * 100}%`,
        },
        {
          key: 'totalAmount',
          dataIndex: 'totalAmount',
          title: '合计金额',
        },
        {
          key: 'totalTaxAmount',
          dataIndex: 'totalTaxAmount',
          title: '合计税额',
        },
        {
          key: 'totalAmountIncludingTax',
          dataIndex: 'totalAmountIncludingTax',
          title: '价税合计',
        },
      ],
    },
  }

  // 提交成功页面提示
  const subTitle = () => {
    return (
      <div>
        <div style={{ marginBottom: '20px' }}>
          若全部为电子发票，等待咸亨确认即可。
          <br />
          如有纸质发票，请打印寄票随单，并和发票一起寄送到以下地址：
        </div>
        <div
          style={{
            width: '390px',
            backgroundColor: '#fafafa',
            textAlign: 'left',
            padding: '16px',
            margin: '0 auto',
          }}
        >
          {routeParams.type === 'lander' ? (
            <span>
              {addressInfoMemo?.name}，{addressInfoMemo?.phone}
              <br />
              {addressInfoMemo?.address}
            </span>
          ) : (
            <span>
              收件人请填写您采购的联系方式，地址为：浙江省海宁市长安镇启辉路16号咸亨创新产业园1幢7楼
            </span>
          )}
          <span
            style={{
              display: 'inline-block',
              margin: '0 20px 0 8px',
              color: '#3c44d3',
              cursor: 'pointer',
            }}
            onClick={() => onCopy()}
          >
            复制
          </span>
        </div>
      </div>
    )
  }

  // 判断发票列表列数据是否包含'操作'项
  const invoiceListColumns = changeInvoiceListColumns(
    invoiceDetail.dataState as string,
    formConfig['发票列表'].columns,
  )

  const items: MenuProps['items'] = [
    {
      key: 'manual',
      label: (
        <Button
          type="link"
          onClick={() => {
            changeBatchModalVisible(true, 'manual')
          }}
        >
          手动填写
        </Button>
      ),
    },
    {
      key: 'batchUpload',
      label: (
        <Customupload
          accept={FINANCIAL_INVOICE_FILE_TYPE}
          uploadBtn={
            <Button type="link" size="small" style={{ margin: '0 0 10px 0' }}>
              批量导入发票
            </Button>
          }
          beforeUpload={beforeUpload}
          visibleFile={false}
          multiple
        />
      ),
    },
  ]

  return (
    <div>
      {addInvoiceEntrySubmit ? (
        <div style={{ minHeight: '100vh' }}>
          <Result
            status="success"
            title="提交成功"
            subTitle={subTitle()}
            extra={[
              <Button key="download" onClick={exrpotInvoiceWithOrder}>
                导出寄票随单
              </Button>,
              <Button
                key="toDetail"
                type="primary"
                onClick={jumpToInvoiceDetail}
              >
                前往查看
              </Button>,
            ]}
          />
        </div>
      ) : (
        <Spin spinning={pageLoading}>
          <div className={Styles['contianer']}>
            <div className={Styles['body']}>
              {addressInfoMemo && (
                <div className={Styles['ticket-email-add']}>
                  <ExclamationCircleOutlined
                    style={{ margin: '0 8px', color: '#faad15' }}
                  />
                  {joinAddressInfo(addressInfoMemo)}
                  <span
                    className={Styles['copy-address']}
                    onClick={() => onCopy()}
                  >
                    复制
                  </span>
                </div>
              )}

              <div className={Styles['logisticsInfo']}>
                <Form
                  form={logisticsInfoForm}
                  onFieldsChange={onLogisticsInfoFormChange}
                >
                  <Row>
                    <Col span={6}>
                      <Form.Item label="物流公司" name={'logisticsCompany'}>
                        <Select placeholder="请选择" allowClear showSearch>
                          {logisticsCompanyList?.map((item: any) => {
                            return (
                              <Select.Option
                                key={item.expressCode}
                                value={item.expressCompany}
                              >
                                {item.expressCompany}
                              </Select.Option>
                            )
                          })}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={2}></Col>
                    <Col span={6}>
                      <Form.Item
                        label="物流单号"
                        name={'logisticsNum'}
                        getValueFromEvent={(e) => {
                          return formatStr(e.target.value, 'TextNumber')
                        }}
                      >
                        <Input placeholder="请输入" maxLength={50}></Input>
                      </Form.Item>
                    </Col>
                    {(invoiceDetail.dataState === '1' ||
                      invoiceDetail.dataState === '3') && (
                      <Col>
                        <Button
                          type="primary"
                          style={{ marginLeft: '40px' }}
                          onClick={saveLogisticsInfo}
                        >
                          保存
                        </Button>
                      </Col>
                    )}
                  </Row>
                </Form>
              </div>
              <div className={Styles['invoice-info']}>
                <div
                  className={Styles['header']}
                  style={{ justifyContent: 'space-between' }}
                >
                  <span style={{ marginRight: 8 }}>
                    发票列表
                    <span
                      style={{ marginLeft: 16, border: 'null', fontSize: 14 }}
                    >
                      发票价税合计：{allInvoicePrice}
                    </span>
                    {/* 订单和发票列表都有数据的情况下判断是否展示提示 */}
                    {invoiceListData.length && dataSource.length ? (
                      isTotalTaxAmoutNotEqualMemo ? (
                        <span
                          style={{
                            marginLeft: 16,
                            border: 'null',
                            fontSize: 14,
                            color: '#cc3a16',
                          }}
                        >
                          <CloseCircleOutlined
                            style={{ color: '#cc3a16', marginRight: 6 }}
                          />
                          {getTotalTaxAmountMismatchMessage(
                            pageType,
                            routeParams.type,
                          )}
                        </span>
                      ) : (
                        ''
                      )
                    ) : (
                      ''
                    )}
                  </span>
                  {(!invoiceDetail ||
                    (invoiceDetail.dataState !== '1' &&
                      invoiceDetail.dataState !== '3')) && (
                    <Dropdown
                      menu={{ items }}
                      placement="bottom"
                      trigger={['click']}
                    >
                      <Button size="middle">上传发票</Button>
                    </Dropdown>
                  )}
                </div>
                <div className={Styles['invoice-info-list']}>
                  {!invoiceListData.length ? (
                    <div className={Styles['invoice-info-null']}>
                      暂无数据，您可以通过扫描
                      <span
                        className={Styles['invoice-info-btn']}
                        onClick={() => {
                          fileInput.current?.click()
                        }}
                      >
                        批量识别发票
                      </span>
                      发票，或
                      <span
                        className={Styles['invoice-info-btn']}
                        onClick={() => {
                          changeBatchModalVisible(true, 'manual')
                        }}
                      >
                        手动填写
                      </span>
                      <input
                        id="inputFile"
                        ref={fileInput}
                        type="file"
                        style={{ display: 'none' }}
                        onChange={(e) => getInputFile(e)}
                        multiple
                      />
                    </div>
                  ) : (
                    <div style={{ padding: '10px' }}>
                      <TableAntd
                        selfAdaptScroll
                        dataSource={invoiceListData}
                        listColumn={invoiceListColumns}
                        showSize={false}
                        loading={false}
                      ></TableAntd>
                    </div>
                  )}
                </div>
              </div>
              {pageType === 'BLUE' && (
                <div className={Styles['order-detail']}>
                  <Row justify="space-between" className={Styles['header']}>
                    <span>
                      订单明细
                      <span
                        style={{ marginLeft: 16, border: 'null', fontSize: 14 }}
                      >
                        订单价税合计：{allOrderPrice}
                      </span>
                    </span>
                    <Space size={16}>
                      {exrpotInvoiceTip && (
                        <span style={{ color: '#cc3a16', fontSize: '14px' }}>
                          电子票请直接传系统，纸质票请导出寄票随单并一起邮寄
                        </span>
                      )}
                      {(!invoiceDetail ||
                        (invoiceDetail.dataState !== '1' &&
                          invoiceDetail.dataState !== '3')) && (
                        <>
                          <Button
                            size="middle"
                            onClick={onDelete}
                            style={{ color: 'red' }}
                          >
                            删除
                          </Button>
                          <Button size="middle" onClick={handleAddClick}>
                            新增订单
                          </Button>
                        </>
                      )}
                      <Button
                        type="primary"
                        size="middle"
                        onClick={exrpotInvoiceWithOrder}
                      >
                        导出寄票随单
                      </Button>
                    </Space>
                  </Row>
                  <div className={Styles['table-container']}>
                    <TableAntd
                      dataSource={dataSource}
                      listColumn={
                        formConfig[
                          routeParams.type === 'lander'
                            ? '电商供应商订单明细'
                            : '供应商订单明细'
                        ].columns
                      }
                      showSize={false}
                      loading={false}
                      onChangeCheck={onChangeCheck}
                      selfAdaptScroll
                    ></TableAntd>
                  </div>
                </div>
              )}
              {pageType === 'RED' && (
                <div className={Styles['order-detail']}>
                  <Row justify="space-between" className={Styles['header']}>
                    <span>
                      退货单明细
                      <span
                        style={{ marginLeft: 16, border: 'null', fontSize: 14 }}
                      >
                        退货单价税合计：{allOrderPrice}
                      </span>
                    </span>
                    <Space size={16}>
                      {exrpotInvoiceTip && (
                        <span style={{ color: '#cc3a16', fontSize: '14px' }}>
                          电子票请直接传系统，纸质票请导出寄票随单并一起邮寄
                        </span>
                      )}
                      {(!invoiceDetail ||
                        (invoiceDetail.dataState !== '1' &&
                          invoiceDetail.dataState !== '3')) && (
                        <>
                          <Button
                            size="middle"
                            onClick={onDelete}
                            style={{ color: 'red' }}
                          >
                            删除
                          </Button>
                          <Button size="middle" onClick={handleAddClick}>
                            新增退货单
                          </Button>
                        </>
                      )}
                      <Button
                        type="primary"
                        size="middle"
                        onClick={exrpotInvoiceWithOrder}
                      >
                        导出寄票随单
                      </Button>
                    </Space>
                  </Row>
                  <div className={Styles['table-container']}>
                    <TableAntd
                      dataSource={dataSource}
                      listColumn={formConfig['退货单明细'].columns}
                      showSize={false}
                      loading={false}
                      onChangeCheck={onChangeCheck}
                      selfAdaptScroll
                      rowKey={pageType === 'RED' ? getRedRowKey : undefined}
                    ></TableAntd>
                  </div>
                </div>
              )}
            </div>
            <div className={Styles['bottom-buttons-container']}>
              <Space style={{ marginRight: '20px' }}>
                {invoiceDetail.dataState ? (
                  invoiceDetail.dataState === '4' ? (
                    <div style={stateStyle(invoiceDetail.dataState)}>
                      {getInvoiceState(invoiceDetail.dataState)}
                      <span>理由:{invoiceDetail.rejection}</span>
                    </div>
                  ) : (
                    <div style={stateStyle(invoiceDetail.dataState)}>
                      {getInvoiceState(invoiceDetail.dataState)}
                    </div>
                  )
                ) : (
                  <div style={{ width: '10px' }}></div>
                )}
              </Space>
              {!invoiceDetail ||
              (invoiceDetail.dataState !== '1' &&
                invoiceDetail.dataState !== '3') ? (
                <Space>
                  <Button
                    disabled={
                      isSubmitButtonLoading || isTemporaryStorageLoading
                    }
                    onClick={handleClosePage}
                  >
                    取消
                  </Button>
                  {(!invoiceDetail || invoiceDetail.dataState !== '4') && (
                    <Button
                      onClick={() => handleSubmit('temporaryStorage')}
                      loading={isTemporaryStorageLoading}
                      disabled={
                        isSubmitButtonLoading || temporaryStorageDisabled
                      }
                    >
                      暂存
                    </Button>
                  )}
                  <Button
                    type="primary"
                    onClick={() => handleSubmit('submit')}
                    className={Styles['button-item']}
                    loading={isSubmitButtonLoading}
                    disabled={isTemporaryStorageLoading}
                  >
                    提交
                  </Button>
                </Space>
              ) : (
                <></>
              )}
            </div>
            {pageType === 'RED' && (
              <AddReturnOrderModal
                open={isAddModalVisivle}
                modalConfirm={handleAddReturnFinished}
                modalCancel={handleAddOrderModalCancel}
                excludeOrderIds={dataSource.map((item) => item.id)}
                originRemovedList={originRemovedList}
                type={routeParams.type!}
              />
            )}
            {/* 添加订单弹框 */}
            {pageType === 'BLUE' && (
              <AddOrderModal
                open={isAddModalVisivle}
                modalConfirm={handleAddFinished}
                modalCancel={handleAddOrderModalCancel}
                excludeOrderIds={dataSource.map((item) => item.id)}
                originRemovedList={originRemovedList}
                type={routeParams.type!}
              />
            )}
            {/* 上传发票弹框 */}
            <InvoiceEntryBatchModal
              form={invoiceForm}
              open={invoiceBatchModalVisible}
              modalCancel={() => changeBatchModalVisible(false)}
              modalSubmit={onBatchModalSubmit}
              type={invoiceEntryType}
              loading={batchUploadLoading}
              okBtnLoading={okBtnLoading}
              invoiceNature={pageType}
            />
            {/* 发票附件预览 */}
            <PreviewModal
              open={isPreviewModalVisible}
              fileUrl={previewFileUrl}
              onCancel={cancelPreviewModal}
            />
            {/* 发票详情弹框 */}
            <Modal
              title="发票详情"
              open={isModalOpen}
              onOk={handleInvoiceDetailOk}
              onCancel={handleInvoiceDetailCancel}
              width={1100}
              keyboard={false}
              maskClosable={false}
            >
              {currentInvoice.verificationType !== '3' &&
                currentInvoice.verificationType !== '90' && (
                  <div
                    style={{
                      marginBottom: '12px',
                      color: '#595454',
                      backgroundColor: '#fff1f0',
                      border: '1px solid #ffa39e',
                      borderRadius: '4px',
                      padding: '4px',
                    }}
                  >
                    {currentInvoice.verificationType === '4' ? (
                      <span>
                        <CloseCircleOutlined
                          style={{ color: 'red', marginRight: 6 }}
                        />
                        发票验真不通过，请检查您的信息是否正确，或直接上传发票扫描件
                      </span>
                    ) : currentInvoice.verificationType === '2' ? (
                      <span>
                        <CloseCircleOutlined
                          style={{ color: 'red', marginRight: 6 }}
                        />
                        {`购方名称错误！发票抬头请开给${
                          routeParams?.titleOfTheContract ??
                          '万聚国际（杭州）供应链有限公司'
                        }！`}
                      </span>
                    ) : currentInvoice.verificationType === '5' ? (
                      <span>
                        <CloseCircleOutlined
                          style={{ color: 'red', marginRight: 6 }}
                        />
                        验真结果与已填信息不一致
                        <span
                          style={{ color: '#3f7ad4', cursor: 'pointer' }}
                          onClick={handlefillingResult}
                        >
                          填充验真结果
                        </span>
                      </span>
                    ) : (
                      ''
                    )}
                  </div>
                )}
              <div>
                <Form
                  form={invoiceDetailForm}
                  onFieldsChange={invoiceDetailChange}
                >
                  <Row>
                    <Form.Item
                      name={'fileList'}
                      label="发票附件"
                      style={{
                        width: '40%',
                        marginBottom: 0,
                      }}
                      rules={[
                        {
                          required: fileRequire,
                          message: '请上传电子发票的发票附件',
                        },
                      ]}
                    >
                      <UploadSingleInvoice
                        hiddenDownload
                        value={currentInvoice.fileList}
                        disabled={currentInvoice.verificationType !== '4'}
                        onChange={(file) => changeInvoiceFile(file)}
                      />
                      {currentInvoice.verificationType === '4' ? (
                        <span
                          style={{
                            marginLeft: '8px',
                            backgroundColor: '#fff1f0',
                            color: '#ff0000',
                            padding: '0 4px',
                            borderRadius: '4px',
                          }}
                        >
                          验真失败
                        </span>
                      ) : currentInvoice.verificationType !== '90' ? (
                        <span
                          style={{
                            marginLeft: '8px',
                            backgroundColor: '#EEF8E8',
                            color: '#7AC756',
                            padding: '0 4px',
                            borderRadius: '4px',
                          }}
                        >
                          已验真
                        </span>
                      ) : (
                        ''
                      )}
                    </Form.Item>
                    <Form.Item
                      {...invoiceFormItemLayout}
                      label="发票种类"
                      name={'invoiceType'}
                      rules={[{ message: '请选择', required: true }]}
                    >
                      <Select
                        placeholder="请选择"
                        disabled={currentInvoice.verificationType !== '4'}
                        onSelect={(value: string) => {
                          changeInvoiceType(value)
                        }}
                        options={invoiceTypeEnum}
                      ></Select>
                    </Form.Item>
                  </Row>
                  {currentInvoice.verificationType === '5' ? (
                    <Row style={{ marginTop: '-20px', color: 'red' }}>
                      <Col span={9} style={{ paddingLeft: '80px' }}></Col>
                      <Col span={7} style={{ paddingLeft: '36px' }}>
                        {checkingResult?.invoiceType !==
                        currentInvoice.invoiceType
                          ? `验真结果：${
                              invoiceTypeEnum.getLabelByValue(
                                checkingResult?.invoiceType,
                              ) ?? '-'
                            }`
                          : ''}
                      </Col>
                    </Row>
                  ) : (
                    <div></div>
                  )}
                  <Row>
                    <Form.Item
                      {...invoiceFormItemLayout}
                      name={'invoiceNum'}
                      label={'发票号码'}
                      rules={[
                        {
                          required: true,
                          message: '请输入',
                        },
                      ]}
                    >
                      <Input
                        placeholder="请输入"
                        disabled={currentInvoice.verificationType !== '4'}
                      ></Input>
                    </Form.Item>
                    <Form.Item
                      {...invoiceFormItemLayout}
                      name={'invoiceCode'}
                      label={'发票代码'}
                      rules={[
                        {
                          required: !invoiceTypeEnum.isLabelsMatchValue(
                            [
                              '电子发票（增值税专用发票）',
                              '电子发票（普通发票）',
                            ],
                            invoiceDetailForm.getFieldValue('invoiceType'),
                          ),
                          message: '请输入',
                        },
                      ]}
                    >
                      <Input
                        placeholder="请输入"
                        disabled={currentInvoice.verificationType !== '4'}
                      ></Input>
                    </Form.Item>
                    <Form.Item
                      {...invoiceFormItemLayout}
                      name={'invoiceTime'}
                      label={'开票日期'}
                      rules={[
                        {
                          required: true,
                          message: '请选择日期',
                        },
                      ]}
                    >
                      <DatePicker
                        disabled={currentInvoice.verificationType !== '4'}
                      />
                    </Form.Item>
                  </Row>
                  {currentInvoice.verificationType === '5' ? (
                    <Row style={{ marginTop: '-20px', color: 'red' }}>
                      <Col span={8} style={{ paddingLeft: '80px' }}></Col>
                      <Col span={7} style={{ paddingLeft: '42px' }}>
                        {checkingResult?.invoiceCode !==
                        currentInvoice.invoiceCode
                          ? `验真结果：${checkingResult?.invoiceCode}`
                          : ''}
                      </Col>
                      <Col span={8} style={{ paddingLeft: '70px' }}>
                        {checkingResult?.invoiceTime !==
                        moment(currentInvoice.invoiceTime).format('YYYYMMDD')
                          ? `验真结果：${moment(
                              checkingResult?.invoiceTime,
                            ).format('YYYY-MM-DD')}`
                          : ''}
                      </Col>
                    </Row>
                  ) : (
                    <div></div>
                  )}
                  <Row>
                    <Form.Item
                      {...invoiceFormItemLayout}
                      name={'totalAmount'}
                      label={'合计金额'}
                      rules={[
                        {
                          required: true,
                          pattern: /^(0\.\d{1,2}|[1-9]\d*(\.\d{1,2})?)$/,
                          message: '仅支持大于零的两位小数',
                        },
                      ]}
                    >
                      <Input
                        placeholder="请输入"
                        disabled={currentInvoice.verificationType !== '4'}
                      ></Input>
                    </Form.Item>
                    <Form.Item
                      {...invoiceFormItemLayout}
                      name={'totalTaxAmount'}
                      label={'合计税额'}
                      rules={[
                        {
                          pattern: /^(0\.\d{1,2}|[1-9]\d*(\.\d{1,2})?)$/,
                          message: '仅支持大于零的两位小数',
                        },
                      ]}
                    >
                      <Input
                        placeholder="请输入"
                        disabled={currentInvoice.verificationType !== '4'}
                      ></Input>
                    </Form.Item>
                    <Form.Item
                      {...invoiceFormItemLayout}
                      name={'totalAmountIncludingTax'}
                      label={'价税合计'}
                      rules={[
                        {
                          required: true,
                          pattern: /^(0\.\d{1,2}|[1-9]\d*(\.\d{1,2})?)$/,
                          message: '仅支持大于零的两位小数',
                        },
                      ]}
                    >
                      <Input
                        placeholder="请输入"
                        disabled={currentInvoice.verificationType !== '4'}
                      ></Input>
                    </Form.Item>
                  </Row>
                  {currentInvoice.verificationType === '5' ? (
                    <Row style={{ marginTop: '-20px', color: 'red' }}>
                      <Col span={8} style={{ paddingLeft: '80px' }}>
                        {checkingResult?.totalAmount !==
                        currentInvoice.totalAmount
                          ? `验真结果：${checkingResult?.totalAmount}`
                          : ''}
                      </Col>
                      <Col span={7} style={{ paddingLeft: '42px' }}>
                        {checkingResult?.totalTaxAmount !==
                        currentInvoice.totalTaxAmount
                          ? `验真结果：${checkingResult?.totalTaxAmount}`
                          : ''}
                      </Col>
                      <Col span={8} style={{ paddingLeft: '70px' }}>
                        {checkingResult?.totalAmountIncludingTax !==
                        currentInvoice.totalAmountIncludingTax
                          ? `验真结果：${checkingResult?.totalAmountIncludingTax}`
                          : ''}
                      </Col>
                    </Row>
                  ) : (
                    <div></div>
                  )}
                  {invoiceDetailForm.getFieldValue('invoiceType') === '04' && (
                    <Row style={{ marginLeft: '14px' }}>
                      <Form.Item
                        style={{
                          width: '29%',
                        }}
                        label={'校验码'}
                        name={'checkCode'}
                        rules={[
                          {
                            required: true,
                            message: '请输入校验码',
                          },
                        ]}
                        getValueFromEvent={(e) => {
                          return formatStr(e.target.value, 'Number')
                        }}
                      >
                        <Input
                          placeholder="请输入"
                          disabled={currentInvoice.verificationType !== '4'}
                          maxLength={6}
                        ></Input>
                      </Form.Item>
                      {currentInvoice.verificationType === '4' && (
                        <span
                          style={{
                            marginTop: '2px',
                            marginLeft: '8px',
                            fontSize: '12px',
                            color: '#CCCCCC',
                          }}
                        >
                          填写后六位
                        </span>
                      )}
                    </Row>
                  )}
                </Form>
              </div>
              {currentInvoice.verificationType !== '4' &&
                currentInvoice.verificationType !== '90' && (
                  <span>
                    购方名称：{currentInvoice.purchaserName}
                    {currentInvoice.verificationType === '2' ? (
                      <CloseCircleOutlined
                        style={{ color: 'red', marginLeft: 6 }}
                      />
                    ) : (
                      <CheckCircleTwoTone twoToneColor="#52c41a" />
                    )}
                  </span>
                )}
              {currentInvoice.verificationType !== '4' &&
              currentInvoice.verificationType !== '90' ? (
                <div>
                  <TableAntd
                    selfAdaptScroll
                    dataSource={invoiceDetailData}
                    listColumn={formConfig['发票详情'].columns}
                    showSize={false}
                    loading={false}
                  ></TableAntd>
                  <span style={{ display: 'inline-block', marginTop: '8px' }}>
                    备注: {currentInvoice.note || '-'}
                  </span>
                </div>
              ) : (
                ''
              )}
            </Modal>
          </div>
        </Spin>
      )}
    </div>
  )
}

export default AddInvoiceEntry
